<template>
  <div class="header">
	<div class="width1200">
		<div class="logo">
			<!-- <img src="@/assets/images/logo.png" alt=""> -->
			<div>
				<p>惠普打印大客户产品资料“一点通”</p>
				<p>资料导航</p>
			</div>
		</div>
		<div class="search-box">
			<input type="text" placeholder="搜索惠普资料网站" v-model="searchTxt">
			<button @click="searchChange">搜索</button>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name: 'HeaderPC',
  props: {
    search: String
  },
  data() {
    return {
		searchTxt:this.search
	}
  },
  methods: {
	  searchChange(item){
		  if(this.$route.path=="/"){
			  this.$parent.getlist(this.searchTxt);
		  }else{
			  this.$router.push({path:'/',query:{search:this.searchTxt}});
		  }
	  }
  },
  
}
</script>
<style scoped>
	.header{background: #fff;overflow: hidden;padding: 38px 0;}
	.header .logo{float: left;line-height: 23px;width: 400px;}
	.header .logo img{width: 53px;height: 53px;float: left;margin-right: 23px;}
	/* .header .logo div{float: left;width: 323px;margin-top: 3px;} */
	.header .logo div{float: left;width: 100%;margin-top: 3px;}
	.header .logo div p:nth-child(1){font-size: 23px;font-weight: bold;}
	.header .logo div p:nth-child(2){font-size: 18px;}
	.header .search-box{float: right;}
	.header .search-box input{width: 613px;height: 52px;border: 2px solid #000000;padding: 0 15px;box-sizing: border-box;font-size: 18px;vertical-align: top;border-right: 0;}
	.header .search-box button{width: 152px;height: 52px;background: #FFFFFF;border: 2px solid #000000;box-sizing: border-box;padding: 0;text-align: center;line-height: 48px;font-size: 28px;vertical-align: top;cursor: pointer;}
</style>
